module.exports = __webpack_public_path__ + "static/img/titleImg.26866cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/titleImg.png
// module id = Q5Rh
// module chunks = 0